export default __webpack_public_path__ + "static/cafe_36086-a3c645f72e4c6b2a719ff02e0c7ef634.png";